import React from 'react';
import { useTranslation } from 'react-i18next';

import { Message } from '@weezevent/nacre';

const OrderValidCondition = () => {
    const { t } = useTranslation();

    return (
        <Message type="default" title={t('ticket.moderation.statusesTransitions.conditions.detail.conditionRules.order-valid.messageTitle')}>
            {t('ticket.moderation.statusesTransitions.conditions.detail.conditionRules.order-valid.messageDescription')}
        </Message>
    );
};

export default OrderValidCondition;
